module.exports = [{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_@babel+plugin-syntax-flow@7.27.1_@babel+core@7.28.4__@babel+plugin-transf_9d23f48fae5672e71f8fb80119f3eeea/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
